import React, { Component } from 'react';
import { WhiteSpace, WingBlank, Flex, Picker, List, Card, Calendar, NoticeBar } from 'antd-mobile';
import CommonUtils from '../utils/CommonUtils';
import '../styles/HomePage.css';

const history = require("history").createHashHistory()

class HomePage extends Component {
    static defaultProps = {
        fetchSites: (params, callback) => {},
        fetchDeviceTypes: (params, callback) => {},
        agentStatistic: (params, callback) => {},
        siteStatistic: (params, callback) => {},
        deviceRevenueLink: (record) => {},
        bindRefreshFunc: (func) => {},
        menuData: [],
        hideTeamData: false
    }

    constructor(props) {
        super(props);
        this.state = {
            agentStatistic: {
                agentLevel: 1,
                packetCount: 0,
                profitAmount: 0.00,
                salesAmount: 0.00
            },
            siteStatistic: [],
            sites: [],
            showCalendar: false,
            siteId: null,
            deviceType: '',
            dateRange: {
                start: new Date(),
                end: new Date()
            },
            deviceTypes: []
        }
    }

    componentDidMount() {
        this.props.bindRefreshFunc(this.loadInitData)
        this.loadInitData()
    }

    loadInitData = () => {
        this.setState({
            siteId: null,
            deviceType: ''
        }, () => {
            this.loadAgentStatistic()
            this.loadSites()
            this.loadDeviceTypes()
        })
    }

    loadSites = () => {
        this.props.fetchSites({}, (resp) => {
            this.setState({
                sites: resp.data,
                siteId: ''
            }, () => {
                this.loadSiteStatistic()
            })
        })
    }

    loadDeviceTypes = () => {
        this.props.fetchDeviceTypes({}, (resp) => {
            this.setState({
                deviceTypes: resp.data
            })
        })
    }

    loadAgentStatistic = () => {
        const { siteId, dateRange, deviceType } = this.state
        const params = {
            siteIds: CommonUtils.isNotEmpty(siteId)?siteId:null,
            fromDate: CommonUtils.formatDate(dateRange.start),
            toDate: CommonUtils.formatDate(dateRange.end),
            deviceType
        }
        this.props.agentStatistic(params, (resp) => {
            this.setState({
                agentStatistic: resp.data
            })
        })
    }

    loadSiteStatistic = () => {
        const { siteId, dateRange, sites, deviceType } = this.state
        if(!dateRange || !sites) {
            return
        }

        let siteIds = sites.map(item => item.id)
        const params = {
            siteIds: CommonUtils.isNotEmpty(siteId)?siteId:siteIds.join(','),
            fromDate: CommonUtils.formatDate(dateRange.start),
            toDate: CommonUtils.formatDate(dateRange.end),
            deviceType
        }
        this.props.siteStatistic(params, (resp) => {
            this.setState({
                siteStatistic: resp.data
            })
        })
    }

    onSitePickerChange = (val) => {
        this.setState({
            siteId: val[0]
        }, () => {
            this.loadAgentStatistic()
            this.loadSiteStatistic()
        })
    }

    onDeviceTypePickerChange = (val) => {
        this.setState({
            deviceType: val[0]
        }, () => {
            this.loadAgentStatistic()
            this.loadSiteStatistic()
        })
    }

    onCalendarConfirm = (startDate, endDate) => {
        this.setState({
            dateRange: {
                start: startDate,
                end: endDate
            },
            showCalendar: false
        }, () => {
            this.loadAgentStatistic()
            this.loadSiteStatistic()
        })
    }

    onCalendarCancel = () => {
        this.setState({
            showCalendar: false
        })
    }

    handleDeviceRevenueClick = (record) => {
        history.push(this.props.deviceRevenueLink(record))
    }

    doRenderSummaryView = () => {
        const { agentStatistic } = this.state
        return (
            <WingBlank size="md">
                <div className='wrapper-summary'>
                    <Flex>
                        <Flex.Item>
                            <div className='label'><i className='iconfont icon-31'></i> 门店收益</div>
                            <div className='value'><span className='unit'>￥</span>{agentStatistic.profitAmount}</div>
                        </Flex.Item>
                        <Flex.Item>
                            <div className='label'><i className='iconfont icon-order'></i> 门店订单</div>
                            <div className='value'> {agentStatistic.packetCount}</div>
                        </Flex.Item>
                    </Flex>
                    {!this.props.hideTeamData && agentStatistic.agentLevel === 1 ?(
                        <div>
                            <WhiteSpace/>
                            <WhiteSpace/>
                            <Flex>
                                <Flex.Item>
                                    <div className='label'><i className='iconfont icon-group-chat'></i> 团队收益</div>
                                    <div className='value'><span className='unit'>￥</span>{agentStatistic.teamProfitAmount}</div>
                                </Flex.Item>
                                <Flex.Item>
                                    <div className='label'><i className='iconfont icon-yijiedan'></i> 团队订单</div>
                                    <div className='value'> {agentStatistic.teamPacketCount}</div>
                                </Flex.Item>
                            </Flex>
                        </div>
                    ):(<div></div>)}
                    
                </div>
            </WingBlank>
        )
    }

    doRenderMenuView = () => {
        return (
            <WingBlank size="md">
                <WhiteSpace/>
                <Flex className='wrapper-menu'>
                    {this.props.menuData.map((item) => (
                        <Flex.Item onClick={() => {history.push(item.link)}}>
                            <img src={item.icon} alt={item.name} style={item.style}/>
                            <div className='name'>{item.name}</div>
                        </Flex.Item>    
                    ))}
                </Flex>
            </WingBlank>
        )
    }

    doRenderSiteView = () => {
        const { sites, dateRange, siteStatistic, siteId, deviceType, deviceTypes } = this.state
        const sitePickerData = sites.map(item => ({value: item.id, label: item.siteName}))
        const deviceTypePickerData = CommonUtils.generatePickerOptionsFromList(deviceTypes, 'code', 'name')
        return (
            <WingBlank size="md">
                <div className='wrapper-site'>
                    <Picker 
                        cols={1}
                        value={[siteId?siteId:'']}
                        onOk={this.onSitePickerChange}
                        data={[{label:'所有门店', value: ''}, ...sitePickerData]}>
                        <List.Item arrow="horizontal" className='title'>
                            <i className='iconfont icon-tongjitubiao'/>
                            <span> 运营报表</span>
                        </List.Item>
                    </Picker>
                    <div className='filters'>
                        <div className='date-range-picker' onClick={() => {
                            this.setState({
                                showCalendar: true
                            })
                        }}>
                            <span className='symbol'>
                                <i className='iconfont icon-rili'/>
                            </span>
                            <span className='date'>{CommonUtils.formatDate(dateRange.start)}</span>
                            <span className='seperator'>~</span>
                            <span className='date'>{CommonUtils.formatDate(dateRange.end)}</span>
                        </div>
                        <div className='device-type-picker'>
                            <Picker
                                cols={1}
                                value={[deviceType?deviceType:'']}
                                onOk={this.onDeviceTypePickerChange}
                                data={[{label:'所有设备', value: ''}, ...deviceTypePickerData]}>
                                <List.Item></List.Item>
                            </Picker>
                        </div>
                    </div>
                    <WhiteSpace/>
                    {siteStatistic.map(item => (
                        <div key={item.siteId} style={{marginBottom: 15}}>
                            <Card>
                                <Card.Header
                                    title={
                                        <div style={{fontSize: 15}}>
                                            {item.siteName}
                                            <span style={{fontWeight: 'normal', color: 'gray', fontSize: 13}}>&nbsp;({item.totalDeviceCount}台)</span>
                                        </div>
                                    }
                                    extra={<div style={{fontSize: 11, color: '#00CAE3'}} onClick={() => this.handleDeviceRevenueClick(item)}>设备收益</div>}
                                />
                                <Card.Body>
                                    <Flex>
                                        <Flex.Item>
                                            <div className='value'><span className='unit'>￥</span>{item.profitAmount}</div>
                                            <div className='label'>总收益</div>
                                        </Flex.Item>
                                        <Flex.Item>
                                            <div className='value'>{item.dealPacketCount}</div>
                                            <div className='label'>成交订单</div>
                                        </Flex.Item>
                                        <Flex.Item>
                                            <div className='value'>{item.dealRechargeCount}</div>
                                            <div className='label'>充值单数</div>
                                        </Flex.Item>
                                    </Flex>
                                    <WhiteSpace size='md'/>
                                    <Flex>
                                        <Flex.Item>
                                            <div className='value'>{item.totalUserCount}</div>
                                            <div className='label'>用户数</div>
                                        </Flex.Item>
                                        <Flex.Item>
                                            <div className='value'>{item.intendPacketCount}</div>
                                            <div className='label'>意向订单</div>
                                        </Flex.Item>
                                        <Flex.Item>
                                            <div className='value'>{item.offlineDeviceCount}</div>
                                            <div className='label'>离线设备</div>
                                        </Flex.Item>
                                    </Flex>
                                    <WhiteSpace size='md'/>
                                </Card.Body>
                            </Card>
                        </div>
                    ))}
                </div>
            </WingBlank>
        )
    }

    doRenderNoticeView = () => {
        const { sites } = this.state
        if(!sites || !sites.length) {
            return
        }

        for(let site of sites) {
            if(site.siteName === '默认门店') {
                return <NoticeBar marqueeProps={{ loop: true, style: { padding: '0 7.5px' } }}>请在【门店管理】中修改默认门店名</NoticeBar>
            }
        }
    }

    render() {
        const { showCalendar, dateRange } = this.state

        return (
            <div className='home-page'>
                {this.doRenderNoticeView()}
                <WhiteSpace size='md'/>
                {this.doRenderSummaryView()}
                <WhiteSpace size='md'/>
                {this.doRenderMenuView()}
                <WhiteSpace size='md'/>
                {this.doRenderSiteView()}
                <Calendar
                    visible={showCalendar}
                    showShortcut={true}
                    initalMonths={12}
                    infinite={false}
                    onCancel={this.onCalendarCancel}
                    onConfirm={this.onCalendarConfirm}
                    defaultValue={[dateRange.start, dateRange.end]}
                    maxDate={new Date()}
                    />
            </div>
        )
    }
}

export default HomePage;


// WEBPACK FOOTER //
// ./src/components/HomePage.js